import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0c5d67',   // teal
    },
    secondary: {
      main: '#b7332e',   // red
    },
    orange: {
      main: '#e64d1f',   // orange
    },
    purple: {
      main: '#722254',   // purple
    },
    beige: {
      main: '#f6f3de',   // purple
    },
    background: {
      default: '#fff',
      secondary: '#dcdcdc',
    },
    text: {
      primary: '#000',
      secondary: '#555',
    },
  },
  typography: {
    fontFamily: "'Quarion', 'Source Sans Pro', sans-serif",
    h5: { fontWeight: 600 },
  },
});

export default theme;